import { ReactNode } from 'react';

interface IProps {
  children: ReactNode;
}

export default function MainContent({ children }: IProps) {
  return <main>{children}</main>;
}
